import { MenuPoint } from '@agilox/ui-common';
import { lifecycleMenuPoints } from './menupoints';

export const desktopMenuPoints: MenuPoint[] = [
	lifecycleMenuPoints.dashboard,
	lifecycleMenuPoints.remote,
	lifecycleMenuPoints.replay,
	lifecycleMenuPoints.help,
	lifecycleMenuPoints.logout,
];
